import { Box } from "@mui/material"
import { useState } from "react"

interface SettingsStringOptionSelectorProp {
    settingName: string,
    options: Array<string>
}
// Settings are changing on Click or right click
// Settings is disable on double click

const SettingsStringOptionSelector = (props: SettingsStringOptionSelectorProp) => {

    let [index, setIndex] = useState(1)

    let options = ["?", ...props.options, "disabled"]
    const onClick = () => {
        setIndex((index + 1 )%options.length)
    }

    if(index === options.length - 1)
        return <Box display={"flex"} onClick={onClick} flexDirection={"column"} justifyContent={"center"} maxWidth={"150px"}>
        <Box display={"flex"} justifyContent={"center"}  sx={{textDecoration: "line-through", opacity: 0.5}}>{props.settingName}</Box>

</Box>
        

    return <Box display={"flex"} onClick={onClick} flexDirection={"column"} justifyContent={"center"} maxWidth={"150px"}>
        <Box display={"flex"} justifyContent={"center"}>{props.settingName}</Box>
        <Box display={"flex"} justifyContent={"center"}>{options[index]}</Box>

    </Box>
}

export default SettingsStringOptionSelector